export const PRIVACY_POLICY = 'PRIVACY_POLICY';
export const REMEMBER_ME = 'REMEMBER_ME';
export const TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS';
export const URI_MAX_LENGTH = 1024;
